import 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
    providedIn: 'root',
})
export class TableService {

    constructor() { }

    applyFilter(event: any, hasBeenTyped: boolean, dataSource: MatTableDataSource<any>) {
        let filterValue: string;
        if (hasBeenTyped) {
            filterValue = (event.target as HTMLInputElement).value;
        } else {
            filterValue = event;
        }
        dataSource.filter = filterValue.trim().toLowerCase();
        if (dataSource.paginator) {
            dataSource.paginator.firstPage();
        }
        if (dataSource.filteredData.length === 0) {
            return false;
        } else {
            return true;
        }
    }
}